import React, { useState, useEffect } from 'react';
import { AccentDialog } from './AccentDialog';
import { AccentButton } from '../controls/AccentButton';
import { AccentSpinner } from '../controls/AccentSpinner';
import { downloadText } from '../services/DataService';
import { AccentMarkdown } from '../controls/ai/AccentMarkdown';

// Near-full-page rendered preview of a markdown document (e.g. a product's build
// specification version) straight from the document store — same renderer as the
// product author workbench, so GFM tables and <br> cells display identically.
export const MarkdownPreviewDlg = ({ onClose, title, uri }) => {

    const [text, setText] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mounted = true;

        downloadText('/Download/DocumentUri/?uri=' + encodeURIComponent(uri)).then(res => {
            if (!mounted) return;
            if (res.queryError) {
                setError(res.queryError);
                return;
            }
            setText(res.text);
        });

        return () => { mounted = false; };
    }, [uri]);

    return (
        <AccentDialog
            headerContent={title ?? "Preview"}
            onClose={onClose}
            relativeWidth={d => d.width - 80}
            relativeHeight={d => d.height - 80}
            actionsContent={[
                <AccentButton key={1} onClick={e => { onClose({}); e.promise(); }}>Close</AccentButton>,
            ]}
        >
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            {!text && !error && <AccentSpinner />}
            {text != null && (
                <div style={{ height: "100%", overflowY: "auto" }}>
                    <AccentMarkdown text={text} />
                </div>
            )}
        </AccentDialog>
    );
};
